module.exports = __webpack_public_path__ + "img/brand_09.018d87f5.png";